import { Outlet } from "react-router-dom";
import { StateRatesContextProvider } from "./StateRatesContext";

export const StateRatesRoute = () => (
  <StateRatesContextProvider>
    <Outlet />
  </StateRatesContextProvider>
);